import React from "react";
import BackButton from "./BackButton";
import { useNavigate } from "../../helpers/navigationHelpers";

interface Props {
  title: string;
  className?: string;
  backButtonPath?: string;
}

const PageHeading: React.FC<Props> = ({
  title,
  backButtonPath,
  className,
}): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <div
      className={`mr-6 mb-2 flex flex-1 flex-row items-center overflow-hidden sm:mb-0 ${className}`}
    >
      {backButtonPath && (
        <BackButton
          className="text-primary mr-2"
          onClick={() => navigate.goTo(backButtonPath)}
        />
      )}
      <h1
        className="overflow-hidden text-ellipsis whitespace-nowrap"
        title={title}
      >
        {title}
      </h1>
    </div>
  );
};

export default PageHeading;
